export default {
  siteName: "PixelHaha",
  creation: "AI Image",
  product: "Product",
  faceSwap: "Face Swap",
  magicBrush: "Magic Brush",
  discover: "Discover",
  profile: "Profile",
  pricing: "Pricing",
  freeCredits: "Free Credits",
  credits: "Credits",
  getMoreCredits: "Get More Credits",
  left: "Left",
  upgradeToPremium: "Upgrade to Premium",
  go: "Go!",
  accountInformation: "Account Information",
  signOut: "Sign Out",
  getMore: "Get More",
  contactSupport: "Contact Support",
  history: "History",
  login: "Log in",
  signup: "Sign up",
  aiFuture: "AI Feature",
  photoFaceSwap: "Photo Face Swap",
  photoMutipleFaceSwap: "Multiple Picture Face Swap",
  videoFaceSwap: "Face Swap Video Maker",
  videoMutipleFaceSwap: "Multiple Video Face Swap",
  multipleFaceSwap: "Multiple Face Swap",
  aIImageGenerator: "AI Image Generator",
  language: "Language",
  support: "Support",
  // userPolicy: "User Policy",
  // privacyPolicy: "Privacy Policy",
  refundPolicy: "Refund Policy",
  FLARKLaw: '18 U.S.C 2257 Exemption',
  privacyPolicy: "Privacy Policy",
  userPolicy: "Terms & Conditions",
  policies: "Policies",
  intellectual: "Intellectual Property Rights",
  about: "About Us",

  blog: "Blog",
  helpAndFAQS: "Help & FAQS",
  sitemap: "SiteMap",
  bussiness: "Business",
  affiliateProgram: "Affiliate Program",
  api: "API",
  contactUs: "Contact Us",
  aiFaceFunTitle: "AI Video Face Swap Online",
  aiFaceFunSubTitle:
    "Instantly swap faces with PixelHaha Video Face Swap. Change faces in photos and videos to anyone you choose. Create funny memes with our AI-powered product.",
  startFaceButtonTitle: "Start Face Swapping",
  details: "Details  >",
  chooseFace: "Choose Face",
  faceSwaps: "Face Swaps",
  tryAgain: "Try Again",
  faceswapUploadArea: {
    tab1Desc1: "Upload original photo to face swap into.",
    tab1Desc2: "Drag and drop photo or Choose Photo",
    tab2Desc1: "Upload original picture to face swap into.",
    tab2Desc2: "Drag and drop picture or Choose Picture",
    tab3Desc1: "Upload original video to face swap into.",
    tab3Desc2: "Drag and drop video or Choose Video",
    tab4Desc1: "Upload original video to face swap into.",
    tab4Desc2: "Drag and drop video or Choose Video",
    tab1title: "3 steps to Swap Face in Photos or Pictures online",
    tab1step1: "1. Upload your original face photo.",
    tab1step2:
      "2. Upload an target face photo of the person that will replace the face in the original photo. You can also choose from the provided photo demos.",
    tab1step3:
      "3. Start Face Swap Photo, then Preview and Download HD results.",
    tab2title: "3 steps to Swap Mutiple Face in Pictures online",
    tab2step1: "1. Upload your original face picture.",
    tab2step2:
      "2. Upload an target face picture of the person that will replace the face in the original picture. You can also choose from the provided picture demos.",
    tab2step3:
      "3. Start Face Swap Picture, then Preview and Download HD results.",
    tab3title: "3 steps to Swap Face in Videos online",
    tab3step1: "1. Upload your original face video.",
    tab3step2:
      "2. Upload an target face of the person that will replace the face in the original video. You can also choose from the provided demos.",
    tab3step3:
      "3. Start Video Face Swap, then Preview and Download HD results.",
    tab4title: "3 steps to Swap Face in Videos online",
    tab4step1: "1. Upload your original face video.",
    tab4step2:
      "2. Upload an target face of the person that will replace the face in the original video. You can also choose from the provided demos.",
    tab4step3:
      "3. Start Video Face Swap, then Preview and Download HD results.",
    chooseFiles: "Choose Files",
    photoLimit: "Max 10MB",
    videoLimit: "Max 500M, 10Min",
    uploading: "Uploading <xx1>",
    faceAnalyzing: "Face analyzing",
    queuingAbout: "Queuing...About <xx1>s",
    analyzingAbout: "Analyzing...About <xx1>s",
    somethingError: "Something went wrong, please try again later.",
  },
  review: {
    title: "They Love Us, You Will Too",
    subtitle:
      "Join the team of more than 10,000 partners around the world. The rewards they receive from the website are continuous and stable.",
    data1: {
      title: "I love using PixelHaha!",
      content:
        "I love using PixelHaha! It's my favorite tool for adding a fun twist to my photos. Whether I'm swapping faces with friends or trying out different celebrity looks, the results are always hilarious and entertaining.",
      name: "Cliff Quan",
      dateText: "March 2, 2024",
    },
    data2: {
      title: "As a makeup enthusiast",
      content:
        "As a makeup enthusiast, I use PixelHaha to try out new looks before committing to them in real life. Swapping my face with different characters helps me visualize how various styles will look on me. It's a fun and practical tool for anyone who loves experimenting with makeup!",
      name: "Anli Brevo",
      dateText: "May 16, 2024",
    },
    data3: {
      title: "It's easy to use video face swap",
      content:
        "It's easy to use video face swap function to switch your face with someone else's. Whether you want to put a movie star's face on your head or replace your face with a basketball player's, this tool does the job perfectly. Keep it up!",
      name: "Ada Wu",
      dateText: "April 19, 2024",
    },
    data4: {
      title: "This amazing tool intelligently",
      content:
        "This amazing tool intelligently detects faces in photos and seamlessly replaces them with any face you choose. It's like having your own personal creative studio at your fingertips! With PixelHaha, swapping faces in any photo is effortless, allowing me to unleash my imagination without any hassle.",
      name: "Mario Kuper",
      dateText: "January 24, 2024",
    },
    data5: {
      title: "I've always found photo editing challenging",
      content:
        "I've always found photo editing challenging, but PixelHaha makes it easy! I love experimenting with the different ai face swap options and seeing the hilarious combinations. It's a fantastic way to add humor to my photos and keep my friends laughing.",
      name: "Chris jin",
      dateText: "December 12, 2023",
    },
    data6: {
      title: "AI face swap is ideal for creating funny memes",
      content:
        "AI face swap is ideal for creating funny memes, headshots, and face swap videos. PixelHaha is perfect not only for entertainment but also for engaging content creation. It helps you capture more attention on social media.",
      name: "Kotláriková",
      dateText: "March 24, 2024",
    },
  },
  faq: {
    title: "Frequently Asked Questions",
    details: "Details  >",
    data1: {
      question: "What is PixelHaha?",
      answer:
        "PixelHaha is a visual AI platform leveraging advanced technology to automatically swap faces, retouch, enhance, colorize, correct, and cartoonize images without the need for complex photo editing tools like Photoshop. Utilizing cutting-edge AI algorithms, PixelHaha streamlines photo processing, saving time, energy, and costs for both individual and business users requiring bulk photo editing.",
    },
    data2: {
      question: "How does an AI Face Swapping tool work?",
      answer:
        "AI Face Swapping relies on sophisticated artificial intelligence algorithms to meticulously analyze source images, recognize facial features, and seamlessly replace them with another face while maintaining natural lighting, angles, and expressions. This results in AI-generated, realistic face swaps.",
    },
    data3: {
      question: "How to use the Video Face Swap?",
      answer:
        "Firstly, select a clear front-facing image as your base. Secondly, choose the face you want to swap with, whether it's yours or a celebrity's. Thirdly, initiate the replacement process, and the chosen face will be seamlessly placed onto the base image.",
    },
    data4: {
      question: "Can I replace my face with any image?",
      answer:
        "Yes, indeed. PixelHaha allows you to replace your face with any selected image for Free. For example, you can place a male face on a female portrait or an aging face on a baby's photo. The possibilities are endless, allowing you to become anyone you desire without limitations.",
    },
    data5: {
      question: "How to achieve the best result?",
      answer:
        "To achieve optimal results with face swap, follow these tips: Select a clear photo with well-defined facial features, avoiding blurry images. Ensure there is only one face in the photo, and the face is directly facing the camera without obstruction from objects like hands.",
    },
    data6: {
      question: "Can I swap faces online for free?",
      answer:
        "Absolutely! You can swap faces online for free using PixelHaha. We offer both free and premium plans to cater to your needs. As a new user, you'll receive three credits upon registration, providing full access to our face swapping service and additional features such as face cutting and avatar creation.",
    },
  },

  choose: {
    delText: "Are you sure to delete this face?",
    leftBtnText: "Continue",
    rightBtnText: "Cancel",
    overFaces:
      "Uploading faces have reached limit, please delete other faces to continue.",
    faceAn: "Face analyzing...",
    facesuccess: "Face analysis success",
    facefailed: "Face analysis Failed",
    feedback: "Thanks for your feedback!",
    batchsupport:
      "Batch Supported! You can make new face swap no matter the current result.",
    batchsupportAIGirl:
      "Batch Supported! You can make new AI Image no matter the current result.",
    submitting: "Submitting",
    queuing: "Queuing",
    creating: "Creating",
    downloading: "Downloading",
    retryText: "Something went wrong, please try again later.",
    retry: "Retry",
    emailTip:
      "Please enter a valid domain name suffix (such as .com, .net, etc.)",
    noaccount: "No account yet? ",
    enterPassWord: "Enter Password",
    passWordErr: "Set password 8 characters minimum",
    loginPassWordErr: "Password must be at least 8 characters",
    forgotpass: "Forgot password?",
    googlesign: "Login with Google Sign-In?",
    resetpassword: "Reset Password",
    readyaccount: "Already have an account?",
    confirm: "Confirm",
    resetpasswordsuccess: "Reset Password Success!",
    senderror: "Send Error!",
    sendsuccess: "Send Success!",
    signupfree: "Sign Up for Free ",
    signupsuccess: "Sign Up Success!",
    sendcode: "Send Code",
    loginsuccess: "Log in successfully!",
    logingerror: "Login Error!",
    aboutS: "about {leftTime}s",
    keepPatient: "Keep patient!",
    needMoretime: "Need more time!",
    aimostDoneKeep: "Almost done! Keep patient!",
    usernamePlace: "user{'@'}example.com",
    emailCode: "Verification code",
  },
  feedbackDialog: {
    title: "We need your feedback to improve PixelHaha.",
    subTitle1: "Want to improve?",
    option1: "Inaccurate Face analysis about uploaded files",
    option2: "Not looks like",
    option3: "Face detail issues( Distorted, eyes, mouth etc.)",
    option4: "Slow Time",
    option5: "Result Sharpness",
    txtOption1: "Sensitive or disturbing content",
    txtOption2: "Violation of terms of service",
    txtOption3: "Prompt Relevance",
    txtOption4: "Face Distorted",
    txtOption5: "Image Content",
    txtOption6: "Image Sharpness",
    txtOption7: "Slow Time",
    subTitle2: "Want to say more?",
    placeholder: "Other suggestions...",
    submit: "Submit",
  },
  infoDialog: {
    advancedFeatures: "Advanced Features",
    advancedFeaturesText:
      "Please pay for our plans to unlock realistic face swap feature in video.",
    choosePlan: "Choose Plan",
    insufficientCredits: "Insufficient Credits",
    insufficientCreditsText: "Your credit balance:",
    getMoreCredits: "Get more Credits",
    videoTooBig: "Video is too big",
    videoTooLong: "Video is too long",
    videoCannotExceed: "Video cannot exceed",
    inFileSize: "in file size",
    selectAnotherFile: "Select another file",
    photoTooBig: "Photo is too big",
    photoCannotExceed: "Photo cannot exceed",
    tenMin: "10Min",
    deleteFile: "Are you sure to delete this file?",
    cancel: "Cancel",
    confirm: "Confirm",
  },
  allRightsReserved: "All rights reserved.",
  aiGirlIntroductionDetails: "AI Image Introduction Details",
  aiGirlHowToUse: "AI Image How to Use",
  discoverHot: "Discover Trending Searches",
  aiGirlFAQDetails: "AI Image FAQ Details",
  lookslikeUploadOpps: {
    title: "Oops!",
    subtitle:
      "Oops! Exceed free credits limits!\nPlease subscribe plan to use all features unlimitedly.",
    unlockLimit: "Unlock limit",
  },
  selectStyle: "Select Style",
  purchasePopup: {
    title: "Successfully!",
    consumerSuccess: "You've earned <xx1> credits",
    subscribeSuccess: "Unlimited  Access! Enjoy our service!",
    ok: "OK",
  },
  affiliatePopup: {
    title: "Affiliate Program Tuturial",
    first: "First",
    second: "Second",
    linkHint: "Affiliate Program Link:",
    copy: "Copy",
    ok: "OK",
  },
  photoEnhanceDetails: "Photo Enhance Details",
  videoEnhanceDetails: "Video Enhance Details",
  imageEnhancer: "AI Photo Enhancer",
  videoEnhancer: "AI Video Enhancer",
  socialShareTitle:
    "Wow! This picture made by AI image generator is awesome, isn't it?",
  copySuccess: "Copy successful!",
  email: "Email",
  copy: "Copy",
};
